import React from 'react';
import { connect } from 'react-redux';

import * as ElementActions from "../../data/elements/ElementActions";

import ElementToolbar from './ElementToolbar';

const mapStateToProps = (state, ownProps) => ({

});

const mapDispatchToProps = {
    addTextElement: ElementActions.addTextElement,
    addImageElement: ElementActions.addImageElement,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ElementToolbar);
